module.exports = __webpack_public_path__ + "img/edit_listing.b91b4c58.jpg";